<template>
  <div class="dropdown">
    <label style="font-size: 12px; font-weight: bold">{{ $t('SelectCustomer') }}
      <span v-if="showClear"
            @click="resetSelected()"
            class="span-clear cursor-pointer">{{ $t("Clear") }}</span>
    </label>
    <input v-if="Object.keys(selectedItem).length === 0" ref="dropdowninput"
           @focusout="removedFocus"
           @focusin="requestedFocus"
           @input="searchDebounce"
           v-model.trim="inputValue" class="dropdown-input" type="text"
           :placeholder="placeholder" />
    <div v-else @click="resetSelection" class="dropdown-selected">
      <p v-if="Object.keys(selectedItem).length === 0" class="">
        {{ $t('SelectCustomer') }}
      </p>
      <p v-if="Object.keys(selectedItem).length > 0" class="dropdown-item-selected">
        <strong>{{selectedItem.name}}</strong> ({{ selectedItem.customer_id }})
      </p>

    </div>
    <div v-show="Object.keys(selectedItem).length === 0 && itemList.length > 0 && isFocused" class="dropdown-list">
      <template v-for="item in itemList" >
        <div @click="selectItem(item)"   class="dropdown-item">
          <vs-col>
            <p class="dropdown-item-city"><strong>{{item.name}}</strong></p>
            <p class="dropdown-item-city">{{item.first_name}} {{item.last_name}}</p>
            <p class="dropdown-item-country">{{ item.customer_id }} <span>({{ getOrgType(item.organisation_type.toString()) }})</span></p>
            <p class="dropdown-item-country">
              {{ item.address }}<span v-if="item.house_no"> {{ item.house_no }}</span>
            </p>
            <p class="dropdown-item-country">
              {{ item.postal }} {{ item.city }}
            </p>
          </vs-col>
        </div>
<!--        <div @click="selectItem(item)" v-if="!onlySeller"  class="dropdown-item">-->
<!--          <vs-col>-->
<!--            <p class="dropdown-item-city"><strong>{{item.name}}</strong></p>-->
<!--            <p class="dropdown-item-city">{{item.first_name}} {{item.last_name}}</p>-->
<!--            <p class="dropdown-item-country">{{ item.customer_id }} <span>({{ getOrgType(item.organisation_type.toString()) }})</span></p>-->
<!--          </vs-col>-->
<!--        </div>-->
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicCustomersDropDown',
  data() {
    return {
      oldSelectedItem: {},
      inputValue: '',
      itemList: [],
      interval: null,
      isFocused: false,
      filters: {

      },
    }
  },
  computed: {
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    showClear: {
      type: Boolean,
      default: false,
    },
    selectedItem: {
      type: Object,
      default: {},
    },
    onlySeller: {
      type: Boolean,
      default: false,
    },
    onlyActive: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {

  },
  methods: {
    getOrgType(type) {
      if (this.filters) {
        for (let i = 0; i < this.filters.length; i++) {
          if (this.filters[i].id == type) {
            return this.filters[i].name
          }
        }
      }
    },
    requestedFocus() {
      this.isFocused = true
      if (this.itemList.length === 0) {
        this.searchCustomers()
      }
    },
    removedFocus() {
      setTimeout(() => {
        this.$nextTick(() => {
          if (Object.keys(this.selectedItem).length === 0 && Object.keys(this.oldSelectedItem).length > 0) {
            this.selectedItem = this.oldSelectedItem
            this.inputValue = ''
            this.$emit('on-item-selected', this.selectedItem)
          }
          this.isFocused = false
        })
      }, 500)
    },
    resetSelection(focus = true) {
      this.oldSelectedItem = this.selectedItem
      this.selectedItem = {}
      if (focus) {
        this.$nextTick(() => this.$refs.dropdowninput.focus())
      }
      this.$emit('on-item-reset')
    },
    selectItem(theItem) {
      if(theItem.customer_id) {
        this.selectedItem = theItem
        this.inputValue = ''
        this.$emit('on-item-selected', theItem)
      }
    },
    resetSelected() {
      this.$emit('on-item-selected', {})
    },
    searchDebounce() {
      clearTimeout(this.interval)
      this.interval = setTimeout(() => {
        this.searchCustomers()
      }, 500)
    },
    searchCustomers() {
      const filter = {
        search_text: this.inputValue,
      }
      if(this.onlyActive) {
        filter['is_active'] = 1;
      }
      this.$store.dispatch('reports/searchCustomers', { filter })
        .then((data) => {
          this.$vs.loading.close()
          this.errorFetching = false
          if (data.message_type == 1) {
            this.itemList = data.customers
            this.filters = data.types_of_filters.organisation_type
          } else {
            this.showErrorToast(data.message)
          }
        })
        .catch((error) => {
          console.error(error)
          this.$vs.loading.close()
          this.errorFetching = true
          let msg = ''
          try {
            msg = error.response.data.message
          } catch (err) {
            msg = ''
          }
          this.showErrorToast(msg)
        })
    },
    showErrorToast(msg) {
      this.$vs.notify({
        position: 'top-center',
        title: 'Error',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
      })
    },
  },
}
</script>

<style>
.dropdown{
  position: relative;
  width: 100%;
  min-width: 200px;
  max-width: 400px;
  margin: 0 auto;
}
.dropdown-input, .dropdown-selected{
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #00000059;
  background: #ffffff;
  line-height: 1.5em;
  outline: none;
  border-radius: 8px;
}
.dropdown-input:focus, .dropdown-selected:hover{
  background: #fff;
  border-color: #e2e8f0;
}
.dropdown-input::placeholder{
  opacity: 0.7;
}
.dropdown-selected{
  font-weight: bold;
  cursor: pointer;
}
.dropdown-list{
  position: absolute;
  width: 100%;
  max-height: 500px;
  margin-top: 4px;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  z-index: 500;
}
.dropdown-item{
  display: flex;
  width: 100%;
  padding: 11px 16px;
  cursor: pointer;
}
.dropdown-item-selected {
  font-size: 14px;
  color: black;
}
.dropdown-item-city {
  font-size: 14px;
  color: black;
}
.dropdown-item-country {
  font-size: 12px;
  color: black;
}
.dropdown-item:hover{
  background: #edf2f7;
}
.dropdown-item-flag{
  max-width: 24px;
  max-height: 18px;
  margin: auto 12px auto 0px;
}
</style>
